import { DateTimeModel } from "../DateTimeModel";
export class FreeDayModel {
  id?: number;
  name: string;
  freeDayDate: string;
  freeDayDateComponent?: DateTimeModel;
}
